<template>
  <el-form-item
    :label="label"
    class="exemption-code"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="exemptionCode"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
      :filter-method="filter"
    >
      <el-option label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :value="item.value"
      >
        <span style="float: left; color: #8492a6; font-size: 13px">{{ item.value }}</span>
        <span style="float: left; margin-left: 10px">{{ item.label }}</span>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '減免'
    },
    prop: {
      type: String,
      default: 'exemption_code'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      options: [],
      optionsOriginal: []
    }
  },
  computed: {
    exemptionCode: {
      get () {
        return this.value
      },
      set (exemptionCode) {
        this.$emit('change', exemptionCode)
        this.options = this.optionsOriginal
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    const exemptionCode = await this.loadCode()
    const exemptionCodeSet = exemptionCode.map(function (index, array) {
      return { value: index.code_value, label: index.code_explanation }
    })
    this.options = exemptionCodeSet
    this.optionsOriginal = exemptionCodeSet
  },
  methods: {
    async loadCode () {
      if (this.initialize) {
        await this.$axios
          .get('/code-master', { params: { code_id: 'EXEMPTION_CODE' } })
          .then((res) => {
            sessionStorage.setItem('exemptionCode', JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('exemptionCode'))
    },
    filter (a) {
      this.options = this.optionsOriginal.filter((x) => {
        return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.exemption-code {
  ::v-deep .el-form-item__content {
    width: 12em;
  }
}
</style>
